import React, { useState } from "react";
import "./Alert.css"


export const variants = [
    //red
    {
      accentColor: "#FF2200",
      symbol: "error",
      title: "Error",
      text: "Something went wrong. Please try again.",
    },
    //success
    {
      accentColor: "#F2D399",
      symbol: "check_circle",
      title: "Message sent",
      text: "Thank you. I'll get back to you shortly.",
    },
    //rate limit
    {
      accentColor: "#E8A838",
      symbol: "timer",
      title: "Too Many Requests",
      text: "You're sending messages too fast. Please wait a few minutes and try again.",
    },
  ];


export const Alert = ({ variant }) => {
  const [open, setOpen] = useState(true);
  if (open)
    return (
      <div
        className="alert-container"
        style={{ borderColor: variant.accentColor }}
      >
        <span
          className="material-symbols-outlined alert-icon"
          style={{ color: variant.accentColor }}
        >{variant.symbol}</span>
        <div className="alert-body">
          <span className="alert-title" style={{ color: variant.accentColor }}>{variant.title}</span>
          <span className="alert-text">{variant.text}</span>
        </div>
        <button
          type="button"
          className="alert-close"
          aria-label="Close alert"
          onClick={() => setOpen(false)}
        >
          <span className="material-symbols-outlined">close</span>
        </button>
      </div>
    );
};